import { render, staticRenderFns } from "./CoreSkillSidebar.vue?vue&type=template&id=60a15238&scoped=true&"
import script from "./CoreSkillSidebar.vue?vue&type=script&lang=js&"
export * from "./CoreSkillSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CoreSkillSidebar.vue?vue&type=style&index=0&id=60a15238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a15238",
  null
  
)

export default component.exports